(($, Drupal) => {
  const id = "xencms:paragraph--price-item";

  Drupal.behaviors[id] = {
    attach: (context, settings) => {
      $(document).ready(function() {
        $('.price-item--container .price-item-title--group', context).matchHeight();
        $('.price-item--container .price-item-value--group', context).matchHeight();
      });
    }
  };


})(jQuery, Drupal);

